

import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const AddLocalizationManagement=(data:any):Promise<any>=>request({
  url:ApiURL.Command.AddLocalizationManagement,
  method: RequestType.POST,
  data
 }); 

 const GetLocalizationManagementListByFilter=(data:any):Promise<any>=>request({
  url:ApiURL.Command.GetLocalizationManagementListByFilter,
  method: RequestType.POST,
  data
 }); 
 const UpdateLocalizationManagement=(data:any):Promise<any>=>request({
  url:ApiURL.Command.UpdateLocalizationManagement,
  method: RequestType.PUT,
  data
 }); 
 const DeleteLocalizationManagement=(keyword:string):Promise<any>=>request({
  url:ApiURL.Command.DeleteLocalizationManagement.concat("/").concat(keyword),
  method: RequestType.DELETE,
 }); 

const LocalizationManagementCommand = {
  AddLocalizationManagement,
  UpdateLocalizationManagement, 
  GetLocalizationManagementListByFilter,
  DeleteLocalizationManagement
};

export default LocalizationManagementCommand;
